import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconSectionStyle0 = cosmosIconCss;

const CosmosIconSection$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSection extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'f831a5eb97068274a95dbdf6e41536ada31832bf', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '553ba1964cb4ae40c8940e06663975c2140b57be', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '0f3d1a3546fa59536a99dd077e2b4572ac3ff34f', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.124 12.014v.035-.042.007Zm-2.198-2.93c1.316.884 2.183 1.584 2.198 2.93a2.654 2.654 0 0 1-1.576 2.357c.13.286.194.598.186.912 0 1.597-1.327 2.717-3.4 2.717H7.099a.622.622 0 0 1-.643-.622v-.768a.622.622 0 0 1 .643-.601h3.214c.622 0 1.078-.373 1.078-.705 0-.332-.186-.58-1.12-1.14L8.199 12.94C6.85 12.07 6 11.364 6 9.996a2.592 2.592 0 0 1 1.576-2.364c-.14-.29-.212-.61-.207-.933 0-1.576 1.347-2.696 3.42-2.696h3.236a.622.622 0 0 1 .684.622v.747a.622.622 0 0 1-.684.705H10.81c-.622 0-1.058.31-1.058.642s.187.602 1.1 1.162l2.073 1.202Zm-.624 3.815c.28-.194.45-.51.456-.85 0-.374-.124-.643-1.12-1.224l-2.28-1.369-.56-.373a1.164 1.164 0 0 0-.457.871c0 .373.125.622 1.12 1.223l2.281 1.348.56.374Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconSectionStyle0; }
}, [1, "cosmos-icon-section", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-section"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-section":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSection$1);
            }
            break;
    } });
}

const CosmosIconSection = CosmosIconSection$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSection, defineCustomElement };
